<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-md-mm-group-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-md-mm-group-form>
  </j-modal>
</template>

<script>

  import EfsMdMmGroupForm from './EfsMdMmGroupForm'
  export default {
    name: 'EfsMdMmGroupModal',
    components: {
      EfsMdMmGroupForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          if(this.$t('button.edit')===this.title){
            this.$refs.realForm.isCodeDisabled=true
            this.$refs.realForm.isNameDisabled=true
            this.$refs.realForm.isCategoryDisabled=true
          }
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.$refs.realForm.isCodeDisabled=false
        this.$refs.realForm.isNameDisabled=false
        this.$refs.realForm.isCategoryDisabled=false
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>